export function withTableauDashboards (): void {
  const scriptUrl = `vizScript.js`;

  if (!document.querySelector(`script[src="${scriptUrl}"]`)) {
    const node = document.createElement("script");
    node.src = scriptUrl;
    node.type = "text/javascript";
    node.async = true;

    document.body.appendChild(node);
  }
}
